import { ReactElement } from 'react';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import DeviceDataPointsSection from './DeviceDataPointsSection';
import ArrowDown from '../../../components/ArrowDown/ArrowDown';
import { DataPointWithValue } from '@src/types/DataPoint';

const rectTextProps = {
  fill: 'currentColor',
  stroke: 'none',
  textAnchor: 'right',
  fontSize: '8px',
};

export type BreakerProps = {
  breakerConnected: boolean;
  deviceDataPoints?: DataPointWithValue[] | undefined;
  translateXCoordinate: number;
  translateYCoordinate: number;
  deviceDataPointsSectionXCoordinate: number;
  deviceDataPointsSectionYCoordinate: number;
  feederALabel?: string;
  feederBLabel?: string;
  breakerLabel?: string;
  switchLabel?: string;
  sectionLabel?: string;
  resistorLabel?: string;
  displayArrowDown: boolean;
  displayArrowDownYCoordinate?: number;
  verticalLineLength: number;
};

function BreakerStack(props: BreakerProps): ReactElement {
  const {
    breakerConnected,
    deviceDataPoints,
    translateXCoordinate,
    translateYCoordinate,
    feederALabel,
    breakerLabel,
    sectionLabel,
    deviceDataPointsSectionXCoordinate,
    deviceDataPointsSectionYCoordinate,
    displayArrowDown,
    displayArrowDownYCoordinate,
    verticalLineLength,
  } = props;

  return (
    <g transform={`translate(${translateXCoordinate} ${translateYCoordinate})`}>
      <rect
        x={-123}
        y='723'
        width='20'
        height='20'
        fill={breakerConnected ? 'red' : 'green'}
        strokeWidth={0.5}
      />

      <text x={-90} y={735} {...rectTextProps}>
        {breakerLabel}
      </text>

      <VerticalLine
        translateXCoordinate={-113.5}
        translateYCoordinate={744}
        length={verticalLineLength || 50}
        color='white'
        width={0.5}
        data-id='vertical line on top of the switch'
      />

      {displayArrowDown && (
        <ArrowDown
          xCoordinate={-116}
          yCoordinate={displayArrowDownYCoordinate || 100}
        />
      )}

      <text x={-180} y={820} fill='currentColor' stroke='none' fontSize='8px'>
        {feederALabel}
      </text>

      <DeviceDataPointsSection
        translateXCoordinate={deviceDataPointsSectionXCoordinate}
        translateYCoordinate={deviceDataPointsSectionYCoordinate}
        deviceDataPoints={deviceDataPoints}
        label={sectionLabel || ''}
      />
    </g>
  );
}

export default BreakerStack;
